// @flow
export const TRANSLATIONS_ERROR = 'translations/ERROR';
export const TRANSLATIONS_SUCCESS = 'translations/SUCCESS';

type State = {
  translations: {}
};

type Action = {
  type: string,
  payload: any
};

const initialState: State = {
  translations: {}
};

function reducer(state: State = initialState, action: Action) {
  const { type, payload } = action;

  switch (type) {
    case TRANSLATIONS_SUCCESS:
      return {
        ...state,
        translations: payload
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/translations.js